import React, { useState } from "react";
import Button from "../../../ui/common/Button";
import JsonTextArea from "../../../ui/common/JsonTextArea";
import "./UserNeedsModal.scss";

interface UserNeedsModalProps {
  data: object;
  onSave: (data: object) => void;
  onClose: () => void;
}

const EXAMPLE_USER_NEEDS = {
  topics_map: {
    emotion_driven: ["Divert me", "Inspire me"],
    context_driven: ["Give me perspective", "Educate me"],
    fact_driven: ["Keep me engaged", "Update me"],
    action_driven: ["Connect me", "Help me"],
  },
  type: "topics",
};

const UserNeedsModal = ({ data, onSave, onClose }: UserNeedsModalProps) => {
  const [configuration, setConfiguration] = useState(JSON.stringify(data, null, 2));
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const isEmpty = Object.keys(data || {}).length === 0;

  const validate = () => {
    try {
      if (configuration === "") {
        return {};
      }
      return JSON.parse(configuration);
    } catch {
      setError("Please enter valid JSON.");
      return null;
    }
  };

  const handleSave = () => {
    const config = validate();
    if (config === null) return;

    setError("");
    setSaving(true);
    onSave(config);
    onClose();
  };

  return (
    <div className="user-needs-modal">
      <h3>User Needs Configuration</h3>
      <JsonTextArea
        type="object"
        label="Configuration"
        ariaLabel="User needs configuration"
        rows={24}
        value={configuration}
        onChange={(value) => {
          setConfiguration(value);
          setError("");
        }}
      />
      {isEmpty && (
        <Button
          className="example-configuration-button"
          onClick={() => setConfiguration(JSON.stringify(EXAMPLE_USER_NEEDS, null, 2))}
        >
          Add example configuration
        </Button>
      )}
      {error && <div className="error-message">{error}</div>}
      <div className="sub-modal-actions">
        <Button variant="danger" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" disabled={saving} onClick={handleSave}>
          {saving ? "Saving..." : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default UserNeedsModal;
